import md5 from "md5"
const bodyMethods = ["post", "put", "delete", "patch"] // 参数放到请求体的请求方式
const key = process.env.VUE_APP_KEY // 参数加密密钥
const appKey = process.env.VUE_APP_APPKEY // 系统标识
/**
 * 参数加密
 * @param {Object} config
 * @returns {Object}
 */
export function paramsEncrypt({ data = {}, params = {}, method }) {
  let sign = "" // 最终生成的签名
  // 加密配置
  const encryptConfig = { appKey, timeStamp: Date.parse(new Date()) }
  // 参数放置到请求体中的方式(用于区分 data, params)
  const isParmasInBody = bodyMethods.includes(method.toLowerCase())

  // 删除值为 null 的字段
  data = delNullField(data)
  params = delNullField(params)

  // 组合待处理的参数
  let processData = Object.assign({}, encryptConfig, isParmasInBody ? data : params)

  // 对象转字符串
  processData = object2String(processData)

  /* 参数处理开始 */
  // key value 组成数据
  let arr = []
  for (const key in processData) {
    if (Object.hasOwnProperty.call(processData, key)) {
      if (processData[key] !== undefined) {
        arr.push(key)
      }
    }
  }
  arr = arr.sort()
  for (const key in processData) {
    if (Object.hasOwnProperty.call(processData, key)) {
      for (let index = 0; index < arr.length; index++) {
        if (arr[index] === key) {
          arr[index] = arr[index] + processData[key]
        }
      }
    }
  }
  processData = arr
  console.log("[processData] 排序后：", processData)
  processData = processData.join("") // 字段拼接成一整个字符串
  processData = key + processData + key // 前后拼接上 key
  console.log("[processData] 最终字符串：", processData)
  /* 参数处理结束 */

  // 生成 md5 字符串
  sign = md5(processData)
  // 最终返回的参数组合
  const resultParams = isParmasInBody
    ? { data: Object.assign(data, { sign }, encryptConfig) }
    : { params: Object.assign(params, { sign }, encryptConfig) }
  return resultParams
}

/**
 * 删除值为 null 的字段
 * @param {Array} data 数据
 * @returns {Array}
 */
export function delNullField(data) {
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      const element = data[key]
      if (element === null || element === "") {
        delete data[key]
      }
    }
  }
  return data
}

/**
 * 对象转字符串
 * @param {Array} data
 * @returns {Array}
 */
function object2String(data) {
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      const el = data[key]
      if (typeof el === "object") {
        data[key] = JSON.stringify(el) // 数组, 对象转成字符串形式
      }
    }
  }
  return data
}
